import React from "react";
import { FaAngleDown, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { CLIENT } from "../../Router/paths";
import logo from "../../assets/images/logo.png";
import search from "../../assets/images/search-ico.png";
import user from "../../assets/images/user.png";

export default function Header() {
  const userData = JSON.parse(localStorage.getItem("user"));
  const Logout = () => {
    localStorage.clear();
  };
  return (
    <>
      {/* MOBILE-MENU START */}
      <div className="mobile-menu">
        <div className="mobile-close">
          <Link to="#" id="menu-close">
            <FaTimes />
          </Link>
        </div>
        <div className="mobile-menu-body" id="mobile-menu-body" />
      </div>
      {/* MOBILE-MENU END */}
      {/* HEADER CSS START */}
      <header className="header" id="header">
        <div className="bottom-row">
          <div className="container-fluid px-5">
            <div className="row align-items-center">
              <div className="col-lg-1 col-12">
                <div className="logo">
                  <Link to={CLIENT.home}>
                    <img src={logo} alt="Logo" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-10 col-12">
                <div className="text-right">
                  <ul className="navigation-list mb-0">
                    {/* <li>
                            <a href="javascript:void(0)">Find  <i className="fa fa-angle-down"></i>
                            </a>
                            <ul className="navigation-submenu">
                                <li><a href="javascript:void(0)">Find Work</a></li>
                                <li><a href="javascript:void(0)">Saved Jobs</a></li>
                                <li><a href="javascript:void(0)">Proposals</a></li>
                                <li><a href="javascript:void(0)">Profile</a></li>
                                <li><a href="javascript:void(0)">My Stats</a></li>
                            </ul>
                        </li>
                        <li> */}
                    {/* <a href="javascript:void(0)">My Jobs <i className="fa fa-angle-down"></i>
                            </a> */}
                    {/* <ul className="navigation-submenu">
                          <li>
                            <a href="javascript:void(0)">Find Work</a>
                          </li>
                          <li>
                            <a href="javascript:void(0)">Saved Jobs</a>
                          </li>
                          <li>
                            <a href="javascript:void(0)">Proposals</a>
                          </li>
                          <li>
                            <a href="javascript:void(0)">Profile</a>
                          </li>
                          <li>
                            <a href="javascript:void(0)">My Stats</a>
                          </li>
                        </ul> */}
                    <li>
                      <Link to="#">
                        jobs{" "}
                        <i>
                          <FaAngleDown />
                        </i>
                      </Link>
                      <ul className="navigation-submenu">
                        <li>
                          <Link to={CLIENT.home}>My Jobs</Link>
                        </li>
                        <li>
                          <Link to={CLIENT.jobPost}>All Jobs</Link>
                        </li>
                        <li>
                          <Link to={CLIENT.talents}>Your Hires</Link>
                        </li>
                        {/* <li>
                          <Link to={CLIENT.discover}>Discover</Link>
                        </li> */}
                      </ul>
                    </li>
                    {/* <li>
                          <Link to={"#"}>
                            Dispute Resolution{" "}
                            <i>
                              <FaAngleDown />
                            </i>
                          </Link>
                          <ul className="navigation-submenu">
                            <li>
                              <Link to={CLIENT.fileAComplain}>
                                File a Complain
                              </Link>
                            </li>
                            <li>
                              <Link to={CLIENT.disputeResolution}>
                                All Disputes
                              </Link>
                            </li>
                          </ul>
                        </li> */}
                    {/* <li><a href="javascript:void(0)">Proposals</a></li>
                                  <li><a href="javascript:void(0)">Profile</a></li>
                                  <li><a href="javascript:void(0)">My Stats</a></li> */}
                    <li>
                      <Link to={"/chat"}>Chat </Link>
                    </li>
                    <li>
                      <Link to={CLIENT.notifications}>Notifications </Link>
                    </li>
                    <li>
                      <Link to={CLIENT.disputeResolution}>
                        Dispute Resolution
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <div className="col-lg-3">
                <div className="search-box">
                  <div className="search-icon">
                    <img src={search} alt="" />
                  </div>
                  <div className="search-inp">
                    <input type="search" />
                  </div>
                </div>
              </div> */}
              <div className="col-lg-1">
                <div className="user-options text-right">
                  <div className="user-btn">
                    <img
                      src={
                        userData?.profile_picture
                          ? userData?.profile_picture?.profile_picture
                          : user
                      }
                      style={{
                        width: "45px",
                        height: "45px",
                        objectFit: "cover",
                        objectPosition: "top",
                        borderRadius: "50%",
                      }}
                      alt="User"
                    />
                    <ul className="user-submenu">
                      <li>
                        <Link to={CLIENT.profile}>Profile</Link>
                      </li>
                      <li>
                        <Link onClick={Logout}>Logout</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* HEADER END */}
    </>
  );
}
